import { buildSchema,buildProperty } from "@camberi/firecms";

export const videoCategoriesSchema = buildSchema({
    name: "Video Catgories",
    properties: {
        parent: buildProperty({
            title: "Parent",
            dataType: "reference",
            path: "video_categories",
            previewProperties: ["categoryName"]
        }),
        categoryName: {
            title: "categoryName",
            dataType: "string",
            validation: { required: true },
        },
        description: {
            title: "description",
            dataType: "string",
            config: {
                markdown: true
            },
            validation: { required: true },
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        thumbnail: buildProperty({
            title: "Thumbnail Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            validation: { required: true },
        }),
        status: {
            title: "status",
            dataType: "boolean",
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {
        status: false
    }
});


// export const videoSubCategoriesSchema = buildSchema({
//     name: "Video Sub Catgories",
//     properties: {
//         categoryName: {
//             title: "categoryName",
//             dataType: "string",
//             validation: { required: true },
//         },
//         description: {
//             title: "description",
//             dataType: "string",
//             config: {
//                 markdown: true
//             },
//         },
//         order: {
//             title: "Order",
//             dataType: "number",
//             validation: { required: true },
//         },
//         thumbnail: buildProperty({
//             title: "Thumbnail Image",
//             dataType: "reference",
//             path: "media",
//             previewProperties: ["mediaUrl"],
//             validation: { required: true },
//         }),
//         status: {
//             title: "status",
//             dataType: "boolean"
//         },
//         createdAt: {
//             title: "createdAt",
//             dataType: "timestamp",
//             validation: { required: true },
//         },
//     },
//     defaultValues: {
//         status: false
//     }
// });

// export const videoSchema = buildSchema({
//     name: "Video",
//     properties: {
//         videoName: buildProperty({
//             title: "Video Name",
//             validation: { required: true },
//             dataType: "string"
//         }),

//         thumbnail: buildProperty({
//             title: "Thumbnail Image",
//             dataType: "reference",
//             path: "media",
//             previewProperties: ["mediaUrl"],
//             validation: { required: true },
//         }),
//         timer: {
//             title: "Timer (in seconds)",
//             dataType: "number",
//             validation: { required: true },
//         },
//         // category: buildProperty({
//         //     type: "Object",
//         //     title: "video Category",
//         //     dataType: "reference",
//         //     path: "video_categories",
//         //     previewProperties: ["categoryName", "thumbnailUrl"]
//         // }),
//         // subCategory: ({ values }) => ({
//         //     title: "video Sub Category",
//         //     dataType: "reference",
//         //     disabled: !values.category,
//         //     path: (values && values.category) ? `${JSON.parse(JSON.stringify(values.category)).path}/${JSON.parse(JSON.stringify(values.category)).id}/video_sub_categories` : "",
//         //     previewProperties: ["categoryName", "thumbnailUrl"]
//         // }),
//         description: buildProperty({
//             title: "Description",
//             dataType: "string"
//         }),
//         order: {
//             title: "Order",
//             dataType: "number",
//             validation: { required: true },
//         },
//         videoUrl: buildProperty({
//             title: "Video URL",
//             dataType: "string",
//             config: {
//                 storageMeta: {
//                     mediaType: "video",
//                     storagePath: "videos",
//                     acceptedFiles: ["video/*"],
//                     storeUrl: true,
//                     metadata: {
//                         cacheControl: "max-age=1000000"
//                     }
//                 }
//             }
//         }),
//         tags: buildProperty({
//             title: "Tags",
//             description: "Example of generic array",
//             validation: { required: true },
//             dataType: "array",
//             of: {
//                 dataType: "string",
//                 // validation: { required: true },
//                 config: {
//                     previewAsTag: true
//                 }
//             }
//         }),
//         isFree: buildProperty({
//             title: "isFree",
//             dataType: "boolean"
//         }),
//         publishDate: buildProperty({
//             title: "Publish date",
//             dataType: "timestamp"
//         }),
//         status: buildProperty({
//             title: "Status",
//             validation: { required: true },
//             dataType: "string",
//             columnWidth: 140,
//             config: {
//                 enumValues: {
//                     published: "Published",
//                     draft: "Draft"
//                 }
//             }
//         }),
//     },
//     defaultValues: {
//         status: "draft",
//     }
// });

